import cloneDeep from 'lodash/cloneDeep';
import { toTree, flattenTree } from '@/utils/tree';
import router from '@/router';
export const categorySort = (categories = []) => {
  const sortFn = (arr, parentId, results) => {
    const index = arr.findIndex(category => category.parentId === parentId);
    if(index > -1) {
      const ele = arr.splice(index, 1);
      return sortFn(arr, ele[0].id, [ ...results, ele[0] ]);
    } else {
      return results;
    }
  }
  if((categories || []).length > 0) {
    const firstEle = categories.find(category => categories.every(c => c.id !== category.parentId)) || {};
    return sortFn(categories.filter(c => c.id !== firstEle.id), firstEle.id, [ firstEle ]);
  }
  return [];
};

export const durationFormat = (value = 0) => {
  const hourSeconds = 60 * 60;
  const minuteSeconds = 60;
  const daySeconds = hourSeconds * 24;
  const d = Math.floor(value / daySeconds);
  const h = Math.floor((value % daySeconds) / hourSeconds);
  const m = Math.floor((value % daySeconds % hourSeconds) / minuteSeconds);
  const s = value % minuteSeconds;
  if (!d && !h && !m && !s) {
    return '0秒';
  }
  return `${d ? `${d}天` : ''}${h ? `${h}小时` : ''}${m ? `${m}分` : ''}${s ? `${s}秒` : ''} `;
};

export const imgReg = /\.(jpeg|gif|jpg|png|webp|pic|svg|bmp)$/i;
export const docReg = /\.(doc|docx|ppt|pptx|pot|pps|ppsx|ppa|xlsx|xls)$/i;
export const pdfReg = /\.(pdf)$/i;

export function previewFile(file) {
  const name = file.patternName || file.name;
  if(imgReg.test(name)) {
    window.open(file.url, '_blank');
    return;
  }
  if(docReg.test(name)) {
    window.open(`https://view.officeapps.live.com/op/view.aspx?src=${file.url}`, '_blank');
    return;
  }
  if(pdfReg.test(name)) {
    window.open(file.url, '_blank');
  }
}

export const filterChainItems = (data, action, id, status = 'status') => {
  if (!Array.isArray(data)) {
    return [];
  }
  const setNodeDisabled = (tree, disabledStatus) => {
    if (!tree) {
      return tree;
    }
    for (let i in tree) {
      if (disabledStatus) {
        tree[i].disabled = true;
      }
      if (['forbidden', 'abnormal', 'delete'].includes(tree[i][status])) {
        tree[i].disabled = true;
      }
      tree[i].children = setNodeDisabled(tree[i].children, tree[i].disabled);
    }
    return tree;
  }
  const findChainNodes = (tree, list = []) => {
    let currentList = [...list];
    let index = -1;
    if ((tree || []).length === 0) {
      return currentList;
    }
    for (let i = 0; i < tree.length; i++) {
      currentList = [
        ...currentList,
        ...(findChainNodes(tree[i].children || [], list) || [])
      ];
    }
    index = tree.findIndex(item => item.id === id);
    if (index > -1) {
      const { children, ...node } = tree[index];
      currentList = [
        ...currentList,
        ...flattenTree(children || []).filter(childNode => !childNode.disabled),
        node
      ];
    } else {
      index = tree.findIndex(item => currentList.some(v => v.parentId === item.id));
      if (index > -1) {
        const { children, ...node } = tree[index];
        currentList = [
          ...currentList,
          node
        ];
      }
    }
    return currentList;
  }
  const items = cloneDeep(data);
  if (action === 'create') {
    const treeData = setNodeDisabled(toTree(items));
    const arrList = flattenTree(treeData);
    return arrList.filter(item => !item.disabled);
  }
  if (action === 'modify') {
    if (Array.isArray(id)) {
      return items.filter(item => id.includes(item.id));
    }
    const treeData = setNodeDisabled(toTree(items));
    const arrList = flattenTree(treeData);
    const chainList = findChainNodes(treeData, []);
    return [
      ...arrList.filter(item => !item.disabled && !chainList.some(chainItem => chainItem.id === item.id)),
      ...chainList
    ]
  }
  return items;
}

export const generateDeletedItems = (data, action, id, status = 'status', statusArr = ['abnormal', 'delete']) => {
  if (!Array.isArray(data)) {
    return [];
  }
  const items = cloneDeep(data);
  if (action === 'create') {
    return items.filter(item => !statusArr.includes(item[status]));
  }
  if (action === 'modify') {
    return items.reduce((arr, item) => {
      if (statusArr.includes(item[status])) {
        if (Array.isArray(id) && id.includes(item.id)) {
          return [...arr, ({ ...item })];
        }
        if (item.id === id) {
          return [...arr, ({ ...item })];
        }
        return arr;
      }
      return [...arr, ({ ...item })];
    }, []);
  }
  return items;
}

export const forbiddenIds = (arr, statusArr = ['forbidden', 'abnormal', 'delete']) => {
  const forbiddenIds = arr.filter(e => {
    return statusArr.includes(e.status)
  }).map(e => (e.id));
  return forbiddenIds;
}

// 根据id生成路径数组
export const getPathArr = async (arr, id, ids = []) => {
  const index = arr.findIndex(e => e.id === id);
  if (index > -1) {
    ids.unshift(id);
    const item = arr[index];
    if (item.parentId && item.parentId !== '0') {
      await getPathArr(arr, item.parentId, ids)
    }
  }
  return ids;
};

// 列表页单据状态
export const transColor = (hex) => {
  if (hex && hex.includes('#')) {
    const bgColor = "rgba(" + parseInt("0x" + hex.slice(1, 3)) + "," + parseInt("0x" + hex.slice(3, 5)) + "," + parseInt("0x" + hex.slice(5, 7)) + "," + 0.2 + ")";
    return `color: ${hex}; background: ${bgColor}`;
  }
  return 'color: #6578D0; background: rgba(101, 120, 208, 0.2)';
};

// 详情页单据状态
export const transColor2 = (hex) => {
  if (hex && hex.includes('#')) {
    const bgColor = "rgba(" + parseInt("0x" + hex.slice(1, 3)) + "," + parseInt("0x" + hex.slice(3, 5)) + "," + parseInt("0x" + hex.slice(5, 7)) + "," + 0.2 + ")";
    return `color: ${hex}; background: ${bgColor}; border: 1px solid ${hex};`;
  }
  return 'color: #6578D0; background: rgba(101, 120, 208, 0.2)； border-color: 1px solid #6578D0;';
};

export const transColor3 = (hex) => {
  if (hex && hex.includes('#')) {
    const bgColor = "rgba(" + parseInt("0x" + hex.slice(1, 3)) + "," + parseInt("0x" + hex.slice(3, 5)) + "," + parseInt("0x" + hex.slice(5, 7)) + "," + 1 + ")";
    return `color: #383839; background: ${bgColor}; border: 1px solid ${hex};`;
  }
  return `color: #383839; background: #6578D0; font-weight: bold;`;
};

// 报表统计
export const getColumnSummary = (amounts, result = {}) => {
  (amounts || []).map(e => {
    Object.keys(result).map(item => {
      result[item] += (e[item] || 0);
    })
  })
  const columnValues = Object.values(result);
  return ['合计', ...columnValues]
};


// WEBPACK FOOTER //
// ./src/utils/common.js